<template>
  <div class="cr-report-blocks__flex">
    <div class="cr-report-blocks" :class="[className, classFarming]">
      <figure v-if="image">
        <img :src="getImage" alt="Alt description for the image">
      </figure>
      <span v-if="quantity" class="cr-report-blocks__qty">{{ quantity }}</span>
      <span>{{ details }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardReportBlocks',
  components: {},
  props: {
    farming: {
      type: Boolean,
      default: false
    },
    gradient: {
      type: Boolean,
      default: false
    },
    quantity: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    details: {
      type: String,
      default: 'Morrisons Report information'
    }
  },
  computed: {
    className() {
      return `${(this.gradient && 'cr-report-blocks--gradient') || ''}`
    },
    classFarming() {
      return `${(this.farming && 'cr-report-blocks--farming') || ''}`
    },
    getImage() {
      return require('@/assets/images/' + this.image)
    }
  }
}
</script>

<style lang="postcss">
.cr-report-blocks__flex {
  @apply flex w-3/5 min-w-64;
}

.cr-report-blocks {
  @apply bg-white flex flex-col justify-start items-center text-center text-lg shadow-lg px-6 py-8 mx-4 mb-8 font-semibold min-h-48 w-full;
}
.cr-report-blocks__flex:first-of-type .cr-report-blocks {
  @apply ml-6;
}
.cr-report-blocks__flex:last-of-type .cr-report-blocks {
  @apply mr-6;
}
.cr-report-blocks__qty {
  @apply text-secondary font-semibold text-5xl;
}
.cr-report-blocks--farming .cr-report-blocks__qty {
  @apply text-primary font-semibold text-4xl;
}
.cr-report-blocks--gradient {
  @apply bg-gradient-tl-primary font-semibold text-white justify-center;
}
@screen sm {
  .cr-report-blocks__flex {
    @apply w-2/5;
  }
}
@screen md {
  .cr-report-blocks__flex {
    @apply w-1/3 min-w-0;
  }
  .cr-report-blocks__flex:first-of-type .cr-report-blocks {
    @apply ml-0;
  }
  .cr-report-blocks__flex:last-of-type .cr-report-blocks {
    @apply mr-0;
  }
}
@screen lg {
  .cr-report-blocks__flex:first-of-type .cr-report-blocks {
    @apply ml-4;
  }
  .cr-report-blocks__flex:last-of-type .cr-report-blocks {
    @apply mr-4;
  }
}
</style>

